<template>
  <b-modal id="createinvoice-modal" title="Faktura" size="xl" @show="onShow">
    <div v-if="loading">
      <TableSpiner />
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <div class="section-title">Informacje ogólne</div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="form-group">
          <label for="invoice_number" class="col-lg-8 col-form-label"
            >Numer faktury</label
          >
          <div class="col-lg-8">
            <b-form-input
              id="invoice_number"
              v-model="inoviceNumber"
              type="text"
            ></b-form-input>
          </div>
        </div>

        <div class="form-group">
          <label for="issuance_place" class="col-lg-8 col-form-label"
            >Miejsce wystawienia</label
          >
          <div class="col-lg-8">
            <b-form-input
              id="issuance_place"
              v-model="issuancePlace"
              type="text"
            ></b-form-input>
          </div>
        </div>

        <div class="form-group">
          <label for="shipping_place" class="col-lg-8 col-form-label"
            >Miejsce dostarczenia</label
          >
          <div class="col-lg-8">
            <b-form-input
              id="shipping_place"
              v-model="shippingPlace"
              type="text"
            ></b-form-input>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-12 mb-4">
        <div class="form-group">
          <label for="issuance_date" class="col-lg-6 col-form-label"
            >Data sprzedaży</label
          >
          <div class="col-lg-6">
            <v-date-picker
              id="issuance_date"
              v-model="issuanceDate"
              :masks="{ input: 'YYYY-MM-DD' }"
              :popover="{ visibility: 'click' }"
              :min-date="vcalendar.mindate"
              @input="printSkontoDate($event)"
            ></v-date-picker>
          </div>
        </div>

        <div class="form-group">
          <label for="sell_date" class="col-lg-6 col-form-label"
            >Data wystawienia</label
          >
          <div class="col-lg-6">
            <v-date-picker
              id="sell_date"
              v-model="sellDate"
              :masks="{ input: 'YYYY-MM-DD' }"
              :popover="{ visibility: 'click' }"
              :min-date="vcalendar.mindate"
            ></v-date-picker>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-12 mb-4">
        <div class="section-title">Informacje o sprzedawcy</div>
        <div class="form-group">
          <label for="seller_name" class="col-lg-12 col-form-label"
            >Sprzedawca</label
          >
          <div class="col-lg-12">
            <b-form-select
              id="seller_name"
              v-model="selectedCompany"
              :options="availableCompanies"
              @change="printSellerCompany()"
            ></b-form-select>
          </div>
        </div>
        <div class="form-group col-lg-12" style="font-size: 16px">
          <div style="margin-bottom: 5px">
            <strong>{{ choosedCompany.name }}</strong>
          </div>
          <div style="margin-bottom: 5px">{{ choosedCompany.address }}</div>
          <div style="margin-bottom: 5px">
            {{ choosedCompany.postcode }} {{ choosedCompany.locality }}
          </div>
          <div style="margin-bottom: 5px">NIP: {{ choosedCompany.nip }}</div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 mb-4">
        <div class="section-title">Informacje o nabywcy</div>
        <br />
        <br />
        <br />
        <div class="form-group">
          <label for="choose_customer" class="col-lg-12 col-form-label"
            >Wybierz klienta</label
          >
          <div class="col-lg-12">
            <b-form-select
              id="choose_customer"
              v-model="selectedCustomer"
              :options="customers"
              @change="printSelectedBuyer()"
            ></b-form-select>
          </div>
        </div>
        <b-form-group
          label="Rodzaj nabywcy"
          style="padding: 0 15px; margin-bottom: 17px"
        >
          <div class="row mt-3" style="padding: 0 15px">
            <b-form-radio
              class="col-md-6"
              v-model="buyerType"
              name="buyer_type_company"
              value="company"
              style="margin-bottom: 15px"
              >Firma</b-form-radio
            >
            <b-form-radio
              class="col-md-6"
              v-model="buyerType"
              name="buyer_type_person"
              value="person"
              style="margin-bottom: 15px"
              >Osoba prywatna</b-form-radio
            >
          </div>
        </b-form-group>
        <div
          class="form-group row"
          v-if="buyerType === 'company'"
          style="margin-bottom: 0px; padding: 0px 30px 0px 15px"
        >
          <div class="col-lg-6 mb-4" style="padding-right: 0px">
            <label
              for="buyer_company_name"
              class="col-lg-12 col-form-label"
              style="padding-left: 0px"
              >Nazwa firmy</label
            >
            <div>
              <b-form-input
                id="buyer_company_name"
                type="text"
                :value="choosedCustomer.companyname"
              ></b-form-input>
            </div>
          </div>
          <div class="col-lg-6 mb-4" style="padding-right: 0px">
            <label
              for="buyer_nip"
              class="col-lg-12 col-form-label"
              style="padding-left: 0px"
              >NIP:</label
            >
            <div>
              <b-form-input
                id="buyer_nip"
                type="text"
                :value="choosedCustomer.nip"
              ></b-form-input>
            </div>
          </div>
        </div>
        <div
          class="form-group row"
          v-else
          style="margin-bottom: 0px; padding: 0px 30px 0px 15px"
        >
          <div class="col-lg-6 mb-4" style="padding-right: 0px">
            <label
              for="buyer_name"
              class="col-lg-12 col-form-label"
              style="padding-left: 0px"
              >Imię</label
            >
            <div>
              <b-form-input
                id="buyer_name"
                type="text"
                :value="choosedCustomer.firstname"
              ></b-form-input>
            </div>
          </div>
          <div class="col-lg-6 mb-4" style="padding-right: 0px">
            <label
              for="buyer_lastname"
              class="col-lg-12 col-form-label"
              style="padding-left: 0px"
              >Nazwisko</label
            >
            <div>
              <b-form-input
                id="buyer_lastname"
                type="text"
                :value="choosedCustomer.lastname"
              ></b-form-input>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="buyer_address" class="col-lg-12 col-form-label"
            >Adres</label
          >
          <div class="col-lg-12 align-self-center">
            <b-form-input
              id="buyer_address"
              type="text"
              :value="choosedCustomer.address"
            ></b-form-input>
          </div>
        </div>
        <div
          class="form-group row"
          style="margin-bottom: 0; padding: 0 30px 0 15px"
        >
          <div class="col-lg-5 mb-4" style="padding-right: 0">
            <label
              for="buyer_post_code"
              class="col-lg-12 col-form-label"
              style="padding-left: 0"
              >Kod pocztowy</label
            >
            <div>
              <b-form-input
                id="buyer_post_code"
                type="text"
                :value="choosedCustomer.postcode"
              ></b-form-input>
            </div>
          </div>
          <div class="col-lg-7 mb-4" style="padding-right: 0">
            <label
              for="buyer_locality"
              class="col-lg-12 col-form-label"
              style="padding-left: 0"
              >Miejscowość</label
            >
            <div>
              <b-form-input
                id="buyer_locality"
                type="text"
                :value="choosedCustomer.locality"
              ></b-form-input>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="section-title">Pozycje na fakturze</div>
        <b-table
          class="table table-list table-pro table-mobilepro table-invoice bills-table"
          ref="invoice_table"
          :fields="fields"
          :items="invoiceItem.materials"
          stacked="lg"
          show-empty
          empty-text="Brak Materiałów"
        >
          <template v-slot:table-busy>
            <TableSpiner />
          </template>
          <template v-slot:empty="{ emptyText }">
            <div class="empty">
              <i class="fas fa-box-open empty-state"></i>
              <span class="empty-search">{{ emptyText }}</span>
            </div>
          </template>
          <template v-slot:cell(name)="data">
            <b-form-input
              type="text"
              style="margin: 0 auto;"
              :value="data.item.name"
              @change="changeName(data, $event)"
            ></b-form-input>
          </template>
          <template v-slot:cell(quantity)="data">
            <b-form-input
              type="text"
              style="margin: 0 auto;"
              :value="data.item.quantity"
              @change="changeQuantity(data, $event)"
            ></b-form-input>
          </template>
          <template v-slot:cell(unit)="">
            <b-form-input
              type="text"
              style="margin: 0 auto;"
            ></b-form-input>
          </template>
          <template v-slot:cell(netto_price)="data">
            <b-form-input
              type="text"
              style="margin: 0 auto;"
              :value="data.item.netto"
              @change="changeNetto(data, $event)"
            ></b-form-input>
          </template>
          <template v-slot:cell(price)="data">
            <b-form-input
              type="text"
              style="margin: 0 auto;"
              :value="data.item.price"
              @change="changeBrutto(data, $event)"
            ></b-form-input>
          </template>
          <template v-slot:cell(mwst)="data">
            <b-form-select
              id="mwst"
              v-model="data.item.mwst"
              :options="availableMwSt"
              @change="changeMwSt(data)"
            ></b-form-select>
          </template>
          <template v-slot:cell(netto)="data">
            {{
              (data.item.netto * data.item.quantity).toFixed(2)
            }}
          </template>
          <template v-slot:cell(cost)="data">
            {{ data.item.cost.toFixed(2) }}
          </template>
          <template v-slot:cell(options)="data">
            <button class="btn btn-outline-danger" style="padding: 5px 10px; border-radius: 50%;" @click="removeItem(data)"><i class="fas fa-trash-alt"></i></button>
          </template>
          <template v-slot:custom-foot="">
            <b-tr>
              <b-td>
                <button class="btn btn-outline-primary" @click="addItem()">
                  <i class="fas fa-plus"></i> Dodaj pozycje
                </button>
              </b-td>
              <b-th
                colspan="4"
                class="text-right"
                style="vertical-align: middle"
                >SUMA</b-th
              >
              <b-td class="text-center" style="vertical-align: middle">
                <span>Suma MwSt:</span>
                <strong>{{ sumMwSt.toFixed(2) }}</strong>  
              </b-td>
              <b-td class="text-center" style="vertical-align: middle">
                <span>Suma netto:</span>
                <strong>{{ sumNetto.toFixed(2) }}</strong>
              </b-td>
              <b-td class="text-center" style="vertical-align: middle">
                <span>Suma brutto:</span>
                <strong>{{ sumBrutto.toFixed(2) }}</strong>
              </b-td>
              <b-th></b-th>
            </b-tr>
          </template>
        </b-table>
        <div class="form-group row" style="padding: 0 15px">
          <div class="col-lg-3 col-md-12 mb-4" style="margin-left: auto">
            <label for="price_paid" class="col-form-label"
              >Kwota opłacona</label
            >
            <div class="align-self-center">
              <b-form-input
                id="price_paid"
                type="text"
                placeholder="0.00"
                v-model="pricePaid"
              ></b-form-input>
            </div>
          </div>
          <div class="col-lg-2 col-md-12 mb-4" style="align-self: self-end">
            <div class="align-self-center">
              <button
                class="btn btn-outline-primary"
                style="width: 100%"
                @click="payFullPrice()"
              >
                Zapłacono
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="section-title">Płatność</div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div
          class="form-group row"
          style="margin-bottom: 0px; padding: 0px 30px 0px 15px"
        >
          <div class="col-lg-5 mb-4" style="padding-right: 0px">
            <label
              for="payment"
              class="col-lg-12 col-form-label"
              style="padding-left: 0px"
              >Forma płatności</label
            >
            <div>
              <b-form-select
                id="payment"
                v-model="payment"
                :options="availablePayments"
              ></b-form-select>
            </div>
          </div>
          <div class="col-lg-5 mb-4" style="padding-right: 0px">
            <label
              for="payment_date"
              class="col-lg-12 col-form-label"
              style="padding-left: 0px"
              >Termin płatności</label
            >
            <div>
              <b-form-select
                id="payment_date"
                v-model="paymentDate"
                :options="availablePaymentDates"
              ></b-form-select>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="currency" class="col-lg-3 col-form-label">Waluta</label>
          <div class="col-lg-4">
            <b-form-select
              id="currency"
              v-model="currency"
              :options="availableCurrencies"
            ></b-form-select>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="form-group" v-if="choosedCompany.skonto === 1">
          <div class="col-lg-12">
            <b-form-checkbox
              id="skonto"
              ref="skonto"
              v-model="skonto"
              unchecked-value=""
              checked-value="true"
              name="options_skonto"
              >Skonto</b-form-checkbox
            >
          </div>
        </div>
        <div
          class="form-group row"
          style="margin-bottom: 0px; padding: 0px 30px 0px 15px"
        >
          <div
            class="col-lg-7"
            v-if="skonto && choosedCompany.skonto === 1"
            style="padding-right: 0px"
          >
            <label
              for="skonto_date"
              class="col-lg-12 col-form-label"
              style="padding-left: 0px"
              >Skonto - termin płatności</label
            >
            <div>
              <v-date-picker
                id="skonto_date"
                v-model="skontoDate"
                :masks="{ input: 'YYYY-MM-DD' }"
                :popover="{ visibility: 'click' }"
                :min-date="vcalendar.mindate"
              ></v-date-picker>
            </div>
          </div>
          <div
            class="col-lg-4"
            v-if="skonto && choosedCompany.skonto === 1"
            style="padding-right: 0px"
          >
            <label
              for="skonto_discount"
              class="col-lg-12 col-form-label"
              style="padding-left: 0px"
              >% upustu</label
            >
            <div>
              <b-form-input
                id="skonto_discount"
                type="text"
                :value="choosedCompany.skonto_value"
              ></b-form-input>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="row">
          <div class="form-group col-lg-6">
            <label for="seller_fullname" class="col-lg-8 col-form-label"
              >Imię i nazwisko wystawcy</label
            >
            <div class="col-lg-8 align-self-center">
              <b-form-input
                id="seller_fullname"
                type="text"
                v-model="sellerFullname"
                :value="getFullName"
              ></b-form-input>
            </div>
          </div>
          <div class="form-group col-lg-6">
            <label for="buyer_fullname" class="col-lg-8 col-form-label"
              >Imię i nazwisko odbiorcy</label
            >
            <div class="col-lg-8 align-self-center">
              <b-form-input id="buyer_fullname" type="text" v-model="buyerFullname"></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="note" class="col-lg-12 col-form-label">Uwagi</label>
          <div class="col-lg-12">
            <textarea
              type="text"
              class="form-control"
              id="note"
              v-model="note"
              placeholder=""
              rows="4"
            ></textarea>
          </div>
        </div>
        <div class="form-group">
          <label for="language" class="col-lg-3 col-form-label">Język</label>
          <div class="col-lg-3">
            <b-form-select
              id="language"
              v-model="language"
              :options="availableLanguages"
            ></b-form-select>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer="{ cancel }">
      <b-button size="md" variant="outline-danger" @click="cancel()"
        >Anuluj</b-button
      >
      <b-button size="md" variant="primary" type="submit" form="customerForm" @click="submit()"
        >Wystaw fakturę</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import CustomersService from "@/services/customers.service";

import { mapGetters, mapActions } from "vuex";
import TableSpiner from "@/components/TableSpiner";

export default {
  name: "ModalCreateInvoice",
  components: { TableSpiner },
  props: {
    invoiceItem: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters("user", ["getFullName"]),
    ...mapGetters("company", ["items"]),
    ...mapGetters("company", ["mainCompany"]),
  },
  data() {
    return {
      loading: true,
      eventInfo: {},
      sellDate: "",
      issuanceDate: "",
      skontoDate: "",
      vcalendar: {
        mindate: null,
      },
      inoviceNumber: "",
      issuancePlace: "",
      shippingPlace: "",
      buyerType: "company",
      currency: "EUR",
      payment: "remittance",
      paymentDate: "4",
      skonto: "",
      mwst: "",
      language: "german",
      availableCompanies: [],
      availableCurrencies: [],
      availablePayments: [
        { value: "remittance", text: "Przelew" },
        { value: "cash", text: "Gotówka" },
      ],
      availablePaymentDates: [
        { value: "4", text: "4 dni" },
        { value: "7", text: "7 dni" },
        { value: "10", text: "10 dni" },
        { value: "14", text: "14 dni" },
      ],
      availableMwSt: [
        { value: "19", text: "19 %" },
        { value: "12", text: "12 %" },
        { value: "5", text: "5 %" },
      ],
      availableLanguages: [
        { value: "german", text: "Niemiecki" },
        { value: "polish", text: "Polski" },
        { value: "english", text: "Angielski" },
      ],
      fields: [
        { key: "name", label: "Nazwa", class: "" },
        { key: "quantity", label: "Ilość", class: "text-center" },
        { key: "unit", label: "Jednostka", class: "text-center" },
        { key: "netto_price", label: "Cena netto", class: "text-center" },
        { key: "price", label: "Cena brutto", class: "text-center" },
        { key: "mwst", label: "MwSt.", class: "text-center" },
        { key: "netto", label: "Wartość netto", class: "text-center" },
        { key: "cost", label: "Wartość brutto", class: "text-center" },
        { key: "options", label: "Opcje", class: "text-center" },
      ],
      sumNetto: 0,
      sumBrutto: 0,
      sumMwSt: 0,
      pricePaid: 0,
      fullPrice: 0,
      selectedCompany: "",
      choosedCompany: [],
      customers: [],
      selectedCustomer: null,
      choosedCustomer: [],
      sellerFullname: '',
      buyerFullname: '',
      note: ''
    };
  },
  methods: {
    ...mapActions("company", ["getCompanies"]),
    onShow() {
      this.loadCompanies();
      this.loadCustomers();
      this.loading = false;
    },
    changeName(data, event) {
      data.value = event;
      data.item.name = event;
    },
    changeBrutto(data, event) {
      data.value = event;
      data.item.price = parseFloat(event).toFixed(2);
      data.item.netto = (data.item.price / (data.item.mwst / 100 + 1)).toFixed(2);
      data.item.cost = data.item.price * data.item.quantity;
      this.summary();
    },
    changeNetto(data, event) {
      data.item.netto = parseFloat(event).toFixed(2);
      this.newPrice = parseFloat(event) * (data.item.mwst / 100) + parseFloat(event);
      data.item.price = parseFloat(this.newPrice).toFixed(2);
      data.item.cost = data.item.price * data.item.quantity;
      this.summary();
    },
    changeQuantity(data, event) {
      data.value = event;
      data.item.quantity = event;
      data.item.cost = data.item.price * data.item.quantity;
      this.summary();
    },
    changeMwSt(data) {
      data.item.netto = (data.item.price / (data.item.mwst / 100 + 1)).toFixed(2);
      data.item.netto = parseFloat(data.item.netto);
      this.summary();
    },
    summary() {
      this.sumNetto = 0;
      this.sumBrutto = 0;
      this.sumMwSt = 0;
      if (this.invoiceItem.materials && this.invoiceItem.materials.length > 0) {
        this.invoiceItem.materials.forEach((el) => {
          this.sumNetto += el.netto * el.quantity;
          this.sumBrutto += el.cost;
          this.sumMwSt = this.sumBrutto - this.sumNetto;
        });
        this.fullPrice = this.sumBrutto;
      }
    },
    addItem() {
      this.invoiceItem.materials.push({
        cost: 0,
        name: "",
        price: 0,
        quantity: 1,
        netto: 0,
        mwst: this.mainCompany.vat_rate,
      });
    },
    removeItem(data) {
      this.invoiceItem.materials.splice(data.index, 1);
      this.summary();
    },
    payFullPrice() {
      this.pricePaid = this.fullPrice.toFixed(2);
    },
    loadCompanies() {
      this.availableCompanies = [];
      this.availableCurrencies = [];
      this.availableMwSt = [];
      for (let i = 0; i < this.items.length; i++) {
        this.availableCompanies.push({
          value: this.items[i].id,
          text: this.items[i].name,
          nip: this.items[i].vatnumber,
          address: this.items[i].address,
          postcode: this.items[i].postalcode,
          locality: this.items[i].city,
          options: this.items[i].options,
        });
        this.availableCurrencies.push({
          value: this.items[i].currency,
          text: this.items[i].currency,
        });
        this.availableMwSt.push({
          value: this.items[i].vat_rate,
          text: this.items[i].vat_rate + " %",
        });
      }
      this.availableCurrencies = [...new Set(this.availableCurrencies.map(a => JSON.stringify(a)))].map(a => JSON.parse(a));
      this.availableMwSt.push({
          value: 0,
          text: 0 + " %",
      });
      this.selectedCompany = this.mainCompany.id;
      this.sellerFullname = this.getFullName;
      this.currency = this.mainCompany.currency;
      for (let i = 0; i < this.invoiceItem.materials.length; i++) {
        this.invoiceItem.materials[i].mwst = this.mainCompany.vat_rate;
        this.invoiceItem.materials[i].netto = (this.invoiceItem.materials[i].price / (this.invoiceItem.materials[i].mwst / 100 + 1)).toFixed(2);
      }
      this.summary();
      this.printSellerCompany();
    },
    printSellerCompany() {
      this.choosedCompany = [];
      for (let i = 0; i < this.availableCompanies.length; i++) {
        if (this.selectedCompany === this.availableCompanies[i].value) {
          this.choosedCompany.id = this.availableCompanies[i].value;
          this.choosedCompany.name = this.availableCompanies[i].text;
          this.choosedCompany.nip = this.availableCompanies[i].nip;
          this.choosedCompany.address = this.availableCompanies[i].address;
          this.choosedCompany.postcode = this.availableCompanies[i].postcode;
          this.choosedCompany.locality = this.availableCompanies[i].locality;
          this.choosedCompany.skonto = parseInt(
            this.availableCompanies[i].options.skonto
          );
          this.choosedCompany.skonto_days = parseInt(
            this.availableCompanies[i].options.skonto_days
          );
          this.choosedCompany.skonto_value = parseInt(
            this.availableCompanies[i].options.skonto_value
          );
        }
      }
    },
    printSkontoDate(event) {
      this.skontoDate = new Date();
      this.skontoDate.setDate(
        event.getDate() + this.choosedCompany.skonto_days
      );
    },
    loadCustomers() {
      return CustomersService.search().then((customers) => {
        this.customers = customers;
        for (let i = 0; i < this.customers.length; i++) {
          this.customers[i].value = this.customers[i].id;
          if (this.customers[i].companyname !== null) {
            this.customers[i].text =
              this.customers[i].companyname +
              ", " +
              this.customers[i].firstname +
              " " +
              this.customers[i].lastname;
          } else {
            this.customers[i].text =
              this.customers[i].firstname + " " + this.customers[i].lastname;
          }
        }
        this.customers.push({
          id: null,
          text: "---",
          firstname: "",
          lastname: "",
          companyname: "",
          vat_number: "",
          address: "",
          postcode: "",
          city: "",
        });
        this.customers.reverse();
        return this.customers;
      });
    },
    printSelectedBuyer() {
      this.choosedCustomer = [];
      for (let i = 0; i < this.customers.length; i++) {
        if (this.selectedCustomer === this.customers[i].id) {
          this.choosedCustomer.firstname = this.customers[i].firstname;
          this.choosedCustomer.lastname = this.customers[i].lastname;
          this.choosedCustomer.companyname = this.customers[i].companyname;
          this.choosedCustomer.nip = this.customers[i].vat_number;
          this.choosedCustomer.address = this.customers[i].address;
          this.choosedCustomer.postcode = this.customers[i].postcode;
          this.choosedCustomer.locality = this.customers[i].city;
        }
      }
    },
    submit() {
      this.data = [];
      this.data.inovice_number = this.inoviceNumber;
      this.data.issuance_place = this.issuancePlace;
      this.data.seller_id = this.shippingPlace;
      this.data.issuance_date = this.issuanceDate;
      this.data.sell_date = this.sellDate;
      this.data.seller_company_id = this.choosedCompany.id;
      this.data.buyer = this.choosedCustomer;
      this.data.materials = this.invoiceItem.materials;
      this.data.price_paid = this.pricePaid;
      this.data.payment_type = this.payment;
      this.data.payment_date = this.paymentDate;
      if(this.skonto === true) {
        this.data.skonto = [];
        this.data.skonto.date = this.skontoDate;
        this.data.skonto.discount = this.choosedCompany.skonto_value;
      } else {
        this.data.skonto = "";
      }
      this.data.currency = this.currency;
      this.data.seller_fullname = this.sellerFullname;
      this.data.buyer_fullname = this.buyerFullname;
      this.data.note = this.note;
      this.data.language = this.language;

    }
  },
};
</script>